import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CoreContentModule } from "@obg/ngx.core.content";

import { BetaBadgeContainer } from "./beta-badge.container";

const DIRECTIVES = [BetaBadgeContainer];

@NgModule({
	imports: [CommonModule, CoreContentModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class BetaBadgeModule {}
